import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: 'settings/geotag',
    name: 'geotag_settings',
    props: true,
    meta: { middleware: [loggedIn] },
    component: () =>
      import(/* webpackChunkName: "main" */ './geotag-card/GeotagCard.vue')
  }
];
